import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import { useNavigate } from "react-router-dom";

const drawerWidth = 160;
const AdminSidebar = () => {
  const router = useNavigate();
  const handleListItemClick = (index) => {
    if (index == 0) {
      router.push("/admin/academic-registrations");
      return;
    }
    router.push("/admin/business-registrations");
  };
  return (
    <Box sx={{ display: "flex" }}>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          zIndex: 0,
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar
          disableGutters
          sx={{
            padding: 0,
            minHeight: "60px !important",
          }}
        />

        <List disablePadding>
          <ListItem>
            <ListItemIcon
              sx={{
                minWidth: "36px",
              }}
            >
              <HowToRegIcon color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={"Registrations"}
              sx={{
                margin: 0,
                fontWeight: "bold !important",
              }}
            />
          </ListItem>
          {["Academic", "Business"].map((text, index) => (
            <ListItem
              key={text}
              disablePadding
              sx={{
                paddingLeft: 4,
              }}
            >
              <ListItemButton onClick={() => handleListItemClick(index)}>
                <ListItemText
                  primary={`${index + 1}. ${text}`}
                  sx={{
                    margin: 0,
                    fontWeight: "bold !important",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
      </Drawer>
    </Box>
  );
};

export default AdminSidebar;
